import { formatPhoneNumber } from "@/shared/phone.ts";
import { smsComposeUrl, textMessagesNotice } from "@/shared/textMessages.ts";
import type { TextMessagesConnector } from "@/types/connectors.ts";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type NeedsAttention = NonNullable<TextMessagesConnector["needsAttention"]>;

/**
 * A link that opens a text to Okthx's number — prefilled with START after an
 * opt-out. Shared by the Text Messages card and the app-wide banner, so the
 * fix works the same in both places.
 */
export const TextOkthxLink = ({
  reason,
  assistantNumber,
  className,
  statsigName,
  children,
  ...rest
}: {
  reason: NeedsAttention;
  assistantNumber: string;
  className?: string;
  /** Omitted when a wrapping `Button` carries it. */
  statsigName?: string;
  /** The link text; the formatted number by default. */
  children?: ReactNode;
} & AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a
    {...rest}
    href={smsComposeUrl(assistantNumber, textMessagesNotice(reason).smsBody)}
    className={className}
    {...(statsigName !== undefined && { "data-statsig-name": statsigName })}
  >
    {children ?? formatPhoneNumber(assistantNumber)}
  </a>
);
